<template>
	<div class="container filters mb-5">
		<div class="row g-3">
			<div class="col-12 col-md-6 col-xl-8 d-flex align-items-center">
				<h1 class="mb-0 text-white">What's on</h1>
			</div>

			<div class="col-12 col-md-6 col-xl-4 d-flex justify-content-end align-items-center">

				<!-- Date Picker selection -->
				<div class="dropdown w-100 me-2">
					<button class="btn btn-secondary dropdown-toggle w-100 rounded-0"
						:class="{ show: datePickerDropdownVisible }" type="button"
						id="vueEventsPluginDatePickerDropdownButton" data-bs-toggle="dropdown" aria-expanded="false"
						@click="toggleDatePickerDropdown($event)">
						View by date
					</button>
					<ul id="vueEventsPluginDatePickerDropdown" class="dropdown-menu w-100"
						:class="{ show: datePickerDropdownVisible }"
						aria-labelledby="vueEventsPluginDatePickerDropdownButton">
						<li>

							<Datepicker v-model="datePickerModel" format="yyyy-MM-dd H:i:s" :min-date="new Date()"
								placeholder="Select Dates" :range="true" :auto-apply="true" :multi-calendars="isDesktop"
								:hide-offset-dates="true" :enable-time-picker="false" :inline="true" :utc="false"
								:clearable="true" :prevent-min-max-navigation="true"
								:start-time="[{ hours: 0, minutes: 0, seconds: 0 }, { hours: 23, minutes: 59, seconds: 0 }]"
								:no-today="true"></Datepicker>

						</li>
					</ul>
				</div>

				<!-- Text search -->
				<div class="input-group me-2">
					<label :for="componentId('SearchField')" class="form-label visually-hidden">Text search</label>
					<input :id="componentId('SearchField')" type="text" name="filter_search"
						class="form-control rounded-0" placeholder="Search..."
						:aria-describedby="componentId('SearchField')" v-model.lazy.trim="searchInput"
						v-on:change="emitUpdate">
					<div class="input-group-text rounded-0">
						<i class="fal fa-search"></i>
					</div>
				</div>

			</div>

			<div class="col-12 col-md-8 d-flex align-items-center flex-wrap">
				<taxonomy-buttons ref="taxonomyButtonsComponent" :availableTaxonomyTerms="availableTaxonomyTerms"
					@update-taxonomy="toggleTaxonomy" :exclude="['shows_tags']" :multi-select="false"
					:show-terms="showTerms" />
				<!--
				<taxonomy-buttons ref="taxonomyButtonsComponent" :availableTaxonomyTerms="availableTaxonomyTerms"
				@update-taxonomy="toggleTaxonomy" :exclude="['shows_genre']" />
				-->

			</div>
			<div class="col-12 col-md-4 d-flex justify-content-end align-items-center">
				<!-- Ordering and Reset -->
				<button v-if="enableMap" class="btn btn-secondary vue-events-plugin-map-toggle"
					@click="$emit('toggleMap')">
					Show Map
				</button>
				<div class="dropdown">
					<button class="btn btn-secondary dropdown-toggle ms-2 rounded-0"
						:class="{ show: orderDropdownVisible }" type="button" id="vueEventsPluginOrderDropdownButton"
						data-bs-toggle="dropdown" aria-expanded="false" @click="toggleOrderDropdown($event)">
						Order By
					</button>
					<ul id="vueEventsPluginOrderDropdown" class="dropdown-menu" :class="{ show: orderDropdownVisible }"
						aria-labelledby="vueEventsPluginOrderDropdownButton">
						<li>
							<a class="dropdown-item"
								:class="{ active: 'ASC' == order && 'event_start_date' == orderBy }" href="#"
								v-on:click.prevent.stop="toggleOrder('event_start_date', 'ASC')">Date</a>
						</li>
						<!--
						<li><a class="dropdown-item" :class="{ active: 'DESC' == order && 'event_start_date' == orderBy }"
							href="#" v-on:click.prevent.stop="toggleOrder('event_start_date', 'DESC')">
								Start Date Latest
							</a>
						</li>
						-->
						<li><a class="dropdown-item" :class="{ active: 'ASC' == order && 'title' == orderBy }" href="#"
								v-on:click.prevent.stop="toggleOrder('title', 'ASC')">Title A-Z</a></li>
						<li><a class="dropdown-item" :class="{ active: 'DESC' == order && 'title' == orderBy }" href="#"
								v-on:click.prevent.stop="toggleOrder('title', 'DESC')">Title Z-A</a></li>


						<li v-if="proximity"><a class="dropdown-item"
								:class="{ active: 'ASC' == order && 'distance' == orderBy }" href="#"
								v-on:click.prevent.stop="toggleOrder('distance', 'ASC')">Distance - Closest</a></li>
						<li v-if="proximity"><a class="dropdown-item"
								:class="{ active: 'DESC' == order && 'distance' == orderBy }" href="#"
								v-on:click.prevent.stop="toggleOrder('distance', 'DESC')">Distance - Furthest</a></li>
					</ul>
				</div>
				<a class="btn btn-primary ms-2 rounded-0" href="#" v-on:click.prevent.stop="toggleReset()">Reset</a>
				<a class="btn btn-secondary ms-2 rounded-0" href="#" v-on:click.prevent.stop="this.$emit('toggleCalendarView')">{{ 'calendar' === currentView ? 'List' : 'Calendar' }} View</a>
			</div>
		</div>

	</div>

	<!-- Post Type selection -->
	<!-- <div class="col col-sm-12 col-md-4 col-lg-3 filter d-flex flex-row justify-content-start align-items-end pt-2"
		v-if="availablePostTypes">
		<div class="dropdown w-100">
			<button class="btn btn-secondary dropdown-toggle w-100" :class="{ show: postTypeDropdownVisible }"
				type="button" id="vueEventsPluginPostTypeDropdownButton" data-bs-toggle="dropdown"
				aria-expanded="false" @click="togglePostTypeDropdown($event)">
				Event Type
			</button>
			<ul id="vueEventsPluginPostTypeDropdown" class="dropdown-menu w-100"
				:class="{ show: postTypeDropdownVisible }" aria-labelledby="vueEventsPluginPostTypeDropdownButton">
				<li v-for="(meta, type) in availablePostTypes" :model="type" :key="type.name">

					<div class="dropdown-item pt-2 pb-1">
						<div class="form-check form-switch mb-0">
							<input class="form-check-input" type="checkbox" :id="switchId(type)" v-model="postTypeCheckboxState"
								:value="type" :aria-describedby="switchId(type)"
								@change="togglePostType(type)">
							<label class="form-check-label" :for="switchId(type)">{{ meta.name }}</label>
						</div>
					</div>

				</li>
			</ul>
		</div>
	</div> -->


	<!-- Proximity Search -->
	<div v-if="enableProximity" class="col col-sm-12 col-md-4 col-lg-3 filter pt-2">
		<div class="dropdown">
			<button class="btn btn-secondary dropdown-toggle w-100" :class="{ show: proximityDropdownVisible }"
				type="button" id="vueEventsPluginProximityDropdownButton" data-bs-toggle="dropdown"
				aria-expanded="false" @click="toggleProximityDropdown($event)">
				Location
			</button>
			<ul id="vueEventsPluginProximityDropdown" class="dropdown-menu w-100"
				:class="{ show: proximityDropdownVisible }" aria-labelledby="vueEventsPluginProximityDropdownButton">
				<li>
					<span class="dropdown-item">
						<proximity-search ref="proximityComponent" @update-proximity="toggleProximity"
							@update-radius="toggleRadius" />
					</span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import TaxonomyButtons from '@/components/TaxonomyButtons.vue';
/*import TaxonomyDropdown from '@/components/TaxonomyDropdown.vue';*/
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
	name: 'EventFilters',
	props: {
		availablePostTypes: Object,
		availableTaxonomyTerms: Object,
		defaultQuery: Object,
		showTerms: Object,
		currentView: String,
	},
	components: {
		/*TaxonomyDropdown,*/
		TaxonomyButtons,
		ProximitySearch: defineAsyncComponent(() => import(/* webpackChunkName: "ProximitySearch" */ '@/components/ProximitySearch.vue')),
		Datepicker
	},
	inject: [
		'useToggleSubstitutes'
	],
	emits: ['updateFilters', 'toggleMap', 'toggleCalendarView'],
	expose: ['triggerFilterReload', 'closeAllDropdowns'],
	data() {
		return {
			taxComponent: process.env.VUE_APP_TAX_FILTER_COMPONENT || 'TaxonomyDropdown',
			postTypeDropdownVisible: false,
			datePickerDropdownVisible: false,
			orderDropdownVisible: false,
			proximityDropdownVisible: false,
			order: this.$route.query['order'] || 'ASC',
			orderBy: this.$route.query['order-by'] || 'event_start_date',
			searchInputValue: this.$route.query['search'] || null,
			postTypes: [],
			taxonomies: [],
			enableMap: ('1' === process.env.VUE_APP_SHOW_MAP || false),
			enableProximity: ('1' === process.env.VUE_APP_PROXIMITY_SEARCH || false),
			proximity: this.$route.query['proximity'] || null,
			proximityRadius: this.$route.query['radius'] || '20',
			postTypeCheckboxState: [],
			datePickerModel: (this.$route.query['from'] && this.$route.query['to']) ? [
				(this.$route.query['from']) ? new Date(this.$route.query['from']) : null,
				(this.$route.query['to']) ? new Date(this.$route.query['to']) : null,
			] : null,
			isDesktop: true,
		}
	},
	computed: {
		searchInput: {
			get() {
				return this.$route.query['search'] || this.searchInputValue
			},
			set(value) {
				this.searchInputValue = value;
			},
		},
	},
	methods: {
		switchId(append) {
			return 'vueEventsPluginPostTypeSwitch' + append
		},
		async triggerFilterReload() {
			this.emitUpdate(true)
		},
		toIsoString(date) {
			const tzo = -date.getTimezoneOffset(),
				dif = tzo >= 0 ? '+' : '-',
				pad = function (num) {
					return (num < 10 ? '0' : '') + num;
				};

			return date.getFullYear() +
				'-' + pad(date.getMonth() + 1) +
				'-' + pad(date.getDate()) +
				'T' + pad(date.getHours()) +
				':' + pad(date.getMinutes()) +
				':' + pad(date.getSeconds()) +
				dif + pad(Math.floor(Math.abs(tzo) / 60)) +
				':' + pad(Math.abs(tzo) % 60);
		},

		dateToString(date) {
			if (!date) {
				return null
			}

			const d = new Date(date)

			if (isNaN(d)) {
				return d
			}

			return date.getFullYear() + '-' + ((1 + date.getMonth() < 10) ? '0' : '') + (1 + date.getMonth()) + '-' + ((date.getDate() < 10 ? '0' : '')) + date.getDate()
		},
		emitUpdate(append = true) {
			const defaultQuery = this.defaultQuery || {}

			const taxQuery = {}

			if (this.taxonomies) {
				Object.keys(this.taxonomies).forEach((taxonomy) => {
					taxQuery[taxonomy + '[]'] = this.taxonomies[taxonomy]
				});
			}

			const defaultFrom = this.toIsoString(new Date(new Date().setHours(0, 0, 0, 0)))
			// let defaultTo = new Date(new Date().setHours(23, 59, 59, 0))
			// defaultTo = this.toIsoString(new Date(defaultTo.setFullYear(defaultTo.getFullYear() + 1)))
			const defaultTo = null

			this.$emit(
				'updateFilters',
				{
					...defaultQuery,
					...taxQuery,
					search: this.searchInputValue,
					order: this.order,
					'order-by': this.orderBy,
					'post-types[]': this.postTypes,
					proximity: this.proximity,
					radius: this.proximityRadius,
					from: (Array.isArray(this.datePickerModel) && this.datePickerModel.length) ? this.dateToString(this.datePickerModel[0]) : defaultFrom,
					to: (Array.isArray(this.datePickerModel) && this.datePickerModel.length > 1) ? this.dateToString(this.datePickerModel[1]) : defaultTo,
				},
				(append) ? true : false
			)
		},
		componentId(append) {
			return 'vueEventsPlugin' + append
		},
		togglePostTypeDropdown(e) {
			if (false === this.useToggleSubstitutes) {
				return
			}
			const currentState = this.postTypeDropdownVisible
			this.closeAllDropdowns(true)
			this.postTypeDropdownVisible = !currentState
			e.stopPropagation()
		},
		toggleDatePickerDropdown(e) {
			if (false === this.useToggleSubstitutes) {
				return
			}
			const currentState = this.datePickerDropdownVisible
			this.closeAllDropdowns(true)
			this.datePickerDropdownVisible = !currentState
			e.stopPropagation()
		},
		toggleOrderDropdown(e) {
			if (false === this.useToggleSubstitutes) {
				return
			}
			const currentState = this.orderDropdownVisible
			this.closeAllDropdowns(true)
			this.orderDropdownVisible = !currentState
			e.stopPropagation()
		},
		toggleProximityDropdown(e) {
			if (false === this.useToggleSubstitutes) {
				return
			}
			const currentState = this.proximityDropdownVisible
			this.closeAllDropdowns(true)
			this.proximityDropdownVisible = !currentState
			e.stopPropagation()
		},
		toggleProximity(latitude, longitude) {
			if (latitude && longitude) {
				this.proximity = latitude + ',' + longitude
				this.order = 'ASC'
				this.orderBy = 'distance'
			} else {
				this.proximity = null
			}
			// if (this.useToggleSubstitutes) {
			// 	this.proximityDropdownVisible = false;
			// }
			this.emitUpdate()
		},
		toggleRadius(distance) {
			this.proximityRadius = distance
			this.emitUpdate()
		},
		toggleOrder(orderBy, order) {
			this.order = order
			this.orderBy = orderBy
			if (this.useToggleSubstitutes) {
				this.orderDropdownVisible = false
			}
			this.emitUpdate()
		},
		toggleReset() {
			if (this.useToggleSubstitutes) {
				this.postTypeDropdownVisible = false
				this.datePickerDropdownVisible = false
				this.orderDropdownVisible = false
				this.proximityDropdownVisible = false
			}
			this.postTypes = []
			this.postTypeCheckboxState = []
			this.taxonomies = []
			this.order = 'ASC'
			this.orderBy = 'event_start_date'
			this.searchInputValue = null
			this.proximity = null
			this.proximityRadius = '20'
			this.datePickerModel = null
			if (this.$refs.taxonomyDropdownComponent) {
				this.$refs.taxonomyDropdownComponent.reset()
			}
			if (this.$refs.taxonomyButtonsComponent) {
				this.$refs.taxonomyButtonsComponent.reset()
			}
			if (this.$refs.proximityComponent) {
				this.$refs.proximityComponent.reset()
			}
			this.emitUpdate(false)
		},
		togglePostType(type) {
			if (this.postTypes.includes(type)) {
				const newTypes = []
				this.postTypes.forEach(t => {
					if (t === type) {
						return
					}
					newTypes.push(t)
				});
				this.postTypes = newTypes
			} else {
				this.postTypes.push(type)
			}
			if (this.useToggleSubstitutes) {
				this.postTypeDropdownVisible = false
			}
			this.emitUpdate()
		},
		toggleTaxonomy(taxonomy, termId, multiSelect = false) {
			termId = String(termId)
			if (this.taxonomies[taxonomy] && this.taxonomies[taxonomy].includes(termId)) {
				const newTerms = []
				this.taxonomies[taxonomy].forEach(t => {
					if (t === termId) {
						return
					}
					newTerms.push(t)
				});
				this.taxonomies[taxonomy] = newTerms
			} else {
				if (this.taxonomies[taxonomy]) {
					if (multiSelect) {
						this.taxonomies[taxonomy].push(termId)
					} else {
						this.taxonomies[taxonomy] = [termId]
					}
				} else {
					this.taxonomies[taxonomy] = [termId]
				}
			}
			this.emitUpdate()
		},
		async updateRouteFilters() {

			// Prefill post types from routes
			if ('undefined' !== typeof this.$route.query['post-types[]']) {
				let types = this.$route.query['post-types[]']
				if (false === Array.isArray(types)) {
					types = [types]
				}
				this.postTypes = types
				types.forEach((type) => {
					this.postTypeCheckboxState.push(type)
				})
			}

			// Prefill taxonomies from routes
			if (this.availableTaxonomyTerms) {
				Object.keys(this.availableTaxonomyTerms).forEach((taxonomy) => {
					if ('undefined' === typeof this.$route.query[taxonomy + '[]']) {
						return
					}
					let terms = this.$route.query[taxonomy + '[]']
					if (false === Array.isArray(terms)) {
						terms = [terms]
					}
					this.taxonomies[taxonomy] = terms
				})
			}

		},
		closeAllDropdowns(emit = false) {
			if (this.useToggleSubstitutes) {
				this.postTypeDropdownVisible = false
				this.datePickerDropdownVisible = false
				this.orderDropdownVisible = false
				this.proximityDropdownVisible = false
			}
			if (emit && this.$refs.taxonomyDropdownComponent) {
				this.$refs.taxonomyDropdownComponent.closeAllDropdowns()
			}
		}
	},
	async created() {
		await this.updateRouteFilters()
	},
	// beforeCreate() {
	// 	if (this.$route.query['from'] && this.$route.query['to']) {
	// 		this.datePickerModel = [
	// 			new Date(this.$route.query['from']).toISOString(),
	// 			new Date(this.$route.query['to']).toISOString()
	// 		]
	// 	}
	// },
	mounted() {
		// Mobile check. Add to mixin?
		if (window.innerWidth < 768) {
			this.isDesktop = false;
		}

		if (true === this.useToggleSubstitutes) {
			document.body.addEventListener('click', () => {
				if (this.postTypeDropdownVisible) {
					this.postTypeDropdownVisible = false;
				}
				if (this.datePickerDropdownVisible) {
					this.datePickerDropdownVisible = false;
				}
				if (this.orderDropdownVisible) {
					this.orderDropdownVisible = false;
				}
				if (this.proximityDropdownVisible) {
					this.proximityDropdownVisible = false;
				}
			})
			const dropdownClickElements = [
				document.getElementById('vueEventsPluginOrderDropdown'),
				document.getElementById('vueEventsPluginProximityDropdown'),
				document.getElementById('vueEventsPluginPostTypeDropdown')
			]
			dropdownClickElements.forEach((element) => {
				if (element) {
					element.addEventListener('click', (e) => {
						e.stopPropagation()
					})
				}
			})
		}
	},
	watch: {
		datePickerModel() {
			this.emitUpdate(false)
		}
	}
}
</script>

<style lang="scss" scoped>
.input-group-text {
	cursor: pointer;
}
</style>
